/**
 * Returns base64 encoded string from file object
 * @param file File object to be converted to base64 encoded string
 */
export default function convertFileToBase64String(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
        const reader: FileReader = new FileReader();
        reader.onload = (e: any) => {
            const content: string = (e.target.result || '').trim();
            resolve(getBase64Content(content));
        };
        reader.onerror = function() {
            reject('File reader error');
        };
        reader.readAsDataURL(file);
    });
}

/**
 * Removes the content-type information from base64 encoded string
 * @param content is the base64 encoded string
 * Example
 * Content: "data:text/plain;base64,ZGVsZXRlIGF0dGFjaG1lbnQgbW9kaWZpY2F0aW9u"
 * Output:  "ZGVsZXRlIGF0dGFjaG1lbnQgbW9kaWZpY2F0aW9u"
 */
function getBase64Content(content: string): string {
    const resultCommaIndex = content.indexOf(',');
    if (content.length > resultCommaIndex + 1) {
        return content.substr(resultCommaIndex + 1, content.length);
    }
    return content;
}
